import Vue from 'vue'
import Router from 'vue-router'
// import setGlobal from '../components/common/setGlobal'
import Home from '@/components/Admin/index'
// 加载项目的各个组件文件夹 start
import Admin from './Admin/index'
// 加载项目的各个组件文件夹 end
Vue.use(Router)

let CommonRouter = [
  {
    path: '/',
    name: '主页',
    component: Home,
    redirect: '/index',
    children: [{
      path: '/index',
      component: resolve =>
        require(['@/components/Admin/common/indexHome'], resolve),
      name: '主页'
    }]
  }
]
CommonRouter = CommonRouter.concat(Admin)
const router = new Router({
  routes: CommonRouter
})
router.beforeEach((to, from, next) => {
  // setGlobal.setHeaderParam(to)
  next()
  scrollTo(0, 0) // 加载完成页面后滚动到顶部
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js